module.exports = __webpack_public_path__ + "static/media/ic_materiels_checked.4ee6b311.svg";